module.exports = __webpack_public_path__ + "5ce7cb4a6258291a6bf57be379ae125f.png";